import { Component, OnInit } from '@angular/core';
import { Platform, NavController } from 'ionic-angular';
import { GoogleAnalytics } from '@ionic-native/google-analytics/ngx';

import { RapportComponent } from '../rapport/rapport';
import { ElementVerifieComponent } from '../element-verifie/element-verifie';

import { LastScansService } from '../../app/shared/services/lastScans.service';
import { AuthService } from '../../app/shared/services/auth.service';

@Component({
  selector: 'page-derniers-scans',
  templateUrl: './derniers-scans.html'
})
export class DerniersScansComponent implements OnInit {
    liste = <any>[];
    loader: boolean = true;
    
    constructor(
        private platform: Platform,
        private ga: GoogleAnalytics,
        private lastScansService: LastScansService,
        private authService: AuthService,
        private navCtrl: NavController
    ) {
    }

    ngOnInit() {
        this.init();
    }

    async init(): Promise<any> {
        this.platform.ready().then(_ => {
            this.ga.trackView("Derniers scans");
        });
        const liste = await this.lastScansService.getLastScans();
        const token = await this.authService.getToken();
        if (liste !== null) {
            for(let i in liste) {
                if (liste[i].user === token.user) {
                    this.liste = liste[i].scans;
                }
            }
        }
        this.loader = false;
    }

    detailScan(item: any): any {
        if (item.qrCodeType == "Installation") {
            this.goToPage('rapport', { rapportId: item.data.rapportId });
        } else if (item.qrCodeType == "Equipement") {
            this.goToPage('element-verifie', { rapportId: item.data.rapportId, equipmentId: item.data.matR_ID });
        }
    }

    goToPage(page: any, data: any = {}): any {
        if (page === 'rapport') {
            this.navCtrl.push(RapportComponent, data);
        } else if (page === 'element-verifie') {
            this.navCtrl.push(ElementVerifieComponent, data);
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/derniers-scans/derniers-scans.ts